import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'react-bootstrap/Image'
import NavDropdown from 'react-bootstrap/NavDropdown';

// Import PDFs so the bundler resolves and hashes the file paths correctly
import affiliationLetter from '../../Documents/affiliation_letter.pdf';
import recognitionLetter from '../../Documents/recognition_letter.pdf';
import noc from '../../Documents/noc.pdf';
import trustDeed from '../../Documents/trust_deed.pdf';
import nbc from '../../Documents/nbc.pdf';
import fireSafety from '../../Documents/fire_safety_certificate.pdf';
import healthSanitation from '../../Documents/health_sanitation_certificate.pdf';
import waterTesting from '../../Documents/water_testing_report.pdf';
import smc from '../../Documents/smc.pdf';
import pta from '../../Documents/pta.pdf';
import feeStructure from '../../Documents/fee_structure.pdf';
import academicCalendar from '../../Documents/academic_calendar.pdf';
import boardResult from '../../Documents/board_result.pdf';
import MDDS from '../../Documents/Mandatory Disclosure Details.pdf'
// import landCertificate from '../../Documents/land_certificate.pdf';
// import builtUpArea from '../../Documents/built_up_area_certificate.pdf';
// import landDocuments from '../../Documents/land_documents_lease_deed.pdf';
// import digitalSignature from '../../Documents/digital_signature.pdf';

const MANDATORY_DISCLOSURE_DOCS = [
  { label: 'Affiliation / Extension Letter', file: affiliationLetter },
  { label: 'Recognition Letter (Class I–VIII / RTE)', file: recognitionLetter },
  { label: 'No Objection Certificate (NOC)', file: noc },
  { label: 'Trust Deed / Society Registration / Company Act', file: trustDeed },
  { label: 'National Building Code (NBC)', file: nbc },
  { label: 'Fire Safety Certificate', file: fireSafety },
  { label: 'Health & Sanitation Certificate', file: healthSanitation },
  { label: 'Water Testing Report', file: waterTesting },
  { label: 'School Management Committee (SMC)', file: smc },
  { label: 'Parent Teacher Association (PTA)', file: pta },
  { label: 'Fees Structure', file: feeStructure },
  { label: 'School Academic Calendar', file: academicCalendar },
  { label: 'Board Result of Last Year', file: boardResult },
  { label: 'Mandatory Disclosure Details Summary', file: MDDS, divider: true }
  // { label: 'Land Certificate', file: landCertificate },
  // { label: 'Built-up Area Certificate', file: builtUpArea },
  // { label: 'Land Documents / Lease Deed', file: landDocuments },
  // { label: 'Digital Signature of Manager / Principal', file: digitalSignature },
];

const Navbars = () => {
  return (
    <div>
      <Navbar expand="lg" className='bg-light'>
        <Container fluid>
          <Navbar.Brand className='fs-3 fw-bolder' href="/"> <Image height='50px' width='50px' fluid src={require('../../Images/PMIS_Logo.png')} /> <Image height='450px' width='450px' fluid src={require('../../Images/PMIS name.png')} /> </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" style={{ color: "#fff" }}>
            <Nav className="ms-auto Nav_Buttons">
              <NavDropdown active title="About Us" id="basic-nav-dropdown">
                <NavDropdown.Item href="/Chairman_Message">Chairman's <br /> Message</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/Principal_Message">Principal's <br /> Message</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/About">About Us</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/Aim_&_Objectives">Aim & <br />Objective</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/Our_Facilities">Our Facilities</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown style={{ marginLeft: '1.3rem' }} active title="Gallery" id="basic-nav-dropdown">
                <NavDropdown.Item href="/Image_Gallery">Photos</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/Video_Gallery">Videos</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown style={{ marginLeft: '1.3rem' }} active title="Admission" id="basic-nav-dropdown">
                <NavDropdown.Item href="/Rules_&_Regulations">Rules & <br /> Regulations</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/Fees_Structure">Fees Structure</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown
                className="mandatory-disclosure-dropdown"
                style={{ marginLeft: '1.3rem' }}
                active
                title="Mandatory Disclosure"
                id="basic-nav-dropdown"
              >
                <style>{`
    .mandatory-disclosure-dropdown .dropdown-menu {
      max-height: 300px;      /* ~5 items at ~38-40px each */
      overflow-y: auto;
      overflow-x: hidden;
    }
    .mandatory-disclosure-dropdown .dropdown-menu::-webkit-scrollbar {
      width: 6px;
    }
    .mandatory-disclosure-dropdown .dropdown-menu::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;
    }
  `}</style>
                {MANDATORY_DISCLOSURE_DOCS.map((doc, idx) => (
                  <React.Fragment key={idx}>
                    <NavDropdown.Item
                      href={doc.file}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.label}
                    </NavDropdown.Item>
                    {idx < MANDATORY_DISCLOSURE_DOCS.length - 1 && <NavDropdown.Divider />}
                  </React.Fragment>
                ))}
              </NavDropdown>
              <Nav.Link active style={{ marginLeft: '1.3rem' }} href="/TC_Verification">TC Verification</Nav.Link>
              {/* <Nav.Link active style={{ marginLeft: '1.3rem' }} href="/Alumi_s">Our Alumi's</Nav.Link> */}
              <Nav.Link active style={{ marginLeft: '1.3rem' }} href="/Contact">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}

export default Navbars